
import { CircularProgress, Box, Divider, FormControl, IconButton, Typography } from "@material-ui/core";
import { useResizeScreen } from "../../hooks/useResizeScreen";
import useStyles from '../../assets/styles/styles';
import { useEffect, useState, useRef } from "react";
import MovementsCard from "../Billing/Movements/MovementsCard";
import CustomButton from "../../controls/Button/CustomButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CustomSelect from "../../controls/Select/CustomSelect";
import { useDispatch, useSelector } from "react-redux";
import QuestionAnswerOutlinedIcon from '@material-ui/icons/QuestionAnswerOutlined';
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import { format } from "date-fns";
import { useHistory } from "react-router-dom";
import {
    getAuthorizationAffiliate,
    getAuthorizationDetailsSuccess,
    setAuthorizationDetails,
    clearHistorialAuthRequest,
    downloadAuthorization,
    cancelAuthorizationRequest
} from "../../redux/actions/authorizationsActions";
import ModalActivities from "../DialogActivities/ModalActivities";
import FileDownloadIcon from '@material-ui/icons/FileDownload';
import HeaderCard from "../Billing/Movements/HeaderCard";
import NotFound from "../HomeLogged/NotFound";
import { showErrorMessageModal } from "../../utils/utilsFunctions";
import ShowPeriodFilter from "../../components/ShowPeriodFilter/ShowPeriodFilter";

const personNumber = {
    numeroPersona: parseInt(window.localStorage.getItem("numeroPersona"))
};

const AuthorizationsIndex = () => {
    const { screen } = useResizeScreen();
    const classes = useStyles();
    const today = new Date();
    today.setMonth(-6);
    const [selected, setSelected] = useState([]);
    const familyGroup = useSelector(state => state.appointmentsReducer.groupFamilyTurn);
    const [familyGroupList, setFamilyGroupList] = useState([{}]);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const [dateStart, setDateStart] = useState(today);
    const [dateEnd, setDateEnd] = useState(new Date());
    const [affiliatedSelected, setAffiliatedSelected] = useState(personNumber?.numeroPersona);
    const history = useHistory();
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [itemSelected, setItemSelected] = useState({});
    const { historial, loading, downloadAuth, loadingDownloadAuthorization } = useSelector(state => state.authorizationsReducer);
    const errorMessage = useSelector(state => state.authorizationsReducer.msgError);
    const [openError, setOpenError] = useState();
    const cancelAuthorizationResponse = useSelector((state) => state.authorizationsReducer.cancelAuthorization);
    const [openCancelAuthorizationModal, setOpenCancelAuthorizationModal] = useState(false);
    const [cancelAuthorization, setCancelAuthorization] = useState({});
    const [openNullifyAuthorizationModal, setNullifyAuthorizationModal] = useState(false);
    const [cancelledAuthorization, setCancelledAuthorization] = useState(false);
    const lastRequest = useRef(null);

    const handleOpenRequest = (e) => {
        e.preventDefault();
        history.push('/Authorizations?type=NewRequest');
    };

    const handleChangeSelect = (e) => {
        const { value } = e.target;
        setAffiliatedSelected(value);
        dispatch(clearHistorialAuthRequest())
        let aux = historial?.autorizaciones?.filter(x => x.afiliado === Number.parseInt(value));
        setSelected(aux);
    };


    const handleClickVerMas = (item) => (e) => {
        e.preventDefault();
        let obj = {
            numeroPersona: parseInt(affiliatedSelected),
            gestionCodigo: item.autorizacionGestionCodigo,
            autorizacionNumero: item.autorizacionNumero,
            delegacionCodigo: item.autorizacionDelegacionCodigo
        };
        dispatch(getAuthorizationDetailsSuccess(obj));
        item.afiliado = parseInt(affiliatedSelected);
        dispatch(setAuthorizationDetails(item));
        history.push('/AuthorizationsDetails');
    };

    useEffect(() => {
        if (openError === false) {
            history.push('/');
        }
    }, [openError])

    const setItemToCancel = item => {
        setCancelAuthorization(item);
        setOpenCancelAuthorizationModal(true);
    }

    const setButtons = (item) => {
        let response = '';
        const STATE = {
            INGRESADA: 'ANULAR',
            'EN PROCESO': 'ANULAR',
            CERRADO: 'DESCARGAR'
        };
        const BTN = {
            DESCARGAR: (
                <CustomButton
                    title="DESCARGAR"
                    customClass={classes.buttonAuthorizationIcon}
                    onClick={handleClickModal(item)}
                />
            ),

            ANULAR: (
                <CustomButton
                    title="ANULAR"
                    customClass={classes.buttonAuthorizationIcon}
                    onClick={() => { setItemToCancel(item) }}
                />
            )
        };
        if (item?.autorizacionEstadoDescripcion.trim()) {
            response = BTN[STATE[item?.autorizacionEstadoDescripcion.trim().toUpperCase()]];
        }
        return response;
    };

    const handleClickCancelAuthorization = () => e => {
        e.preventDefault();
        let authorizationToCancel = {
            numeroPersona: parseInt(affiliatedSelected),
            gestionCodigo: cancelAuthorization?.autorizacionGestionCodigo
        };
        dispatch(cancelAuthorizationRequest(authorizationToCancel));
        setOpenCancelAuthorizationModal(false);
        setCancelAuthorization({})
        setNullifyAuthorizationModal(true);
    };

    useEffect(() => {
        if (cancelAuthorizationResponse?.confirmacion) {
            getData();
            setNullifyAuthorizationModal(false);
            setCancelledAuthorization(true);
        }
    }, [cancelAuthorizationResponse])

    const handleClickModal = (item) => (e) => {
        e.preventDefault();
        let obj = {
            numeroPersona: parseInt(affiliatedSelected),
            gestionCodigo: item.autorizacionGestionCodigo,
            autorizacionNumero: item.autorizacionNumero,
            delegacionCodigo: item.autorizacionDelegacionCodigo
        };
        dispatch(downloadAuthorization(obj));
        setOpenModal(true);
    };

    const getData = () => {
        if (affiliatedSelected !== undefined) {
            let obj = {
                fechaDesde: format(dateStart, 'yyyy-MM-dd'),
                fechaHasta: format(dateEnd, 'yyyy-MM-dd'),
                numeroPersona: parseInt(affiliatedSelected),
                count: 0,
                skip: 0
            };
            if (lastRequest.current &&
                lastRequest.current.fechaDesde === obj.fechaDesde &&
                lastRequest.current.fechaHasta === obj.fechaHasta &&
                lastRequest.current.numeroPersona === obj.numeroPersona) {
                return;
            }
            lastRequest.current = obj;
            dispatch(getAuthorizationAffiliate(obj));
        }
    };

    useEffect(() => {
        getData();
    }, [affiliatedSelected, dateStart, dateEnd]);

    useEffect(() => {
        if (Object.values(familyGroup).length > 0) {
            let itemsToPush = familyGroup.map(item => {
                return { value: item.itemCodigo, label: item.itemDescripcion.trim() };
            });
            setFamilyGroupList(itemsToPush);
        }
    }, [familyGroup]);

    useEffect(() => {
        if (Object.values(familyGroupList).length > 0) {
            let aux = familyGroupList[0].value;
            setAffiliatedSelected(aux);
            let authorizations = historial?.autorizaciones?.filter(x => x.afiliado === Number.parseInt(aux));
            setSelected(authorizations);
        }
    }, [familyGroupList]);



    useEffect(() => {
        setSelected(historial?.autorizaciones);
    }, [historial?.autorizaciones]);

    const goToFrequentQuestions = () => {
        history.push("/AuthorizationsFAQ");
    };

    useEffect(() => {
        if (downloadAuth?.autorizacion !== undefined) {
            setItemSelected({ archivo: downloadAuth?.autorizacion?.[0]?.archivo, archivoNombreCompleto: downloadAuth?.autorizacion?.[0]?.archivoNombreCompleto });
        }
    }, [downloadAuth]);

    useEffect(() => {
        if (errorMessage !== "" && errorMessage !== undefined) {
            setOpenError(true);
            setNullifyAuthorizationModal(false);
            setOpenCancelAuthorizationModal(false);
            setOpenModal(false);
        }
    }, [errorMessage]);

    useEffect(() => {
        setCancelledAuthorization(false);
        setNullifyAuthorizationModal(false);
        setOpenCancelAuthorizationModal(false);
    }, []);

    return (
        <>
            <Box className={`${classes.homeAuthorizationBox}`}>
                <CustomButton title={"Iniciar solicitud"} onClick={handleOpenRequest}
                    icon={<AddCircleIcon style={{ marginRight: "5px" }} />}
                    customClass={`${classes.customHeaderBtn} ${classes.buttonStartRequest}`}
                />
            </Box>
            <Box className={`${classes.divSubtitleAddresForm} ${classes.divSubtitleAddresForm} ${classes.divBtnsAddressForm}`} style={{ justifyContent: 'space-between' }}>
                <Typography className={`${classes.titleTurn} ${classes.titleBox} ${classes.txtDarkBlue} `}>
                    Historial
                </Typography>
                <ShowPeriodFilter
                    dateStart={dateStart}
                    dateEnd={dateEnd}
                    setDateStart={setDateStart}
                    setDateEnd={setDateEnd}
                    openPicker={openDatePicker}
                    setOpenPicker={setOpenDatePicker}
                    classes={classes}
                />
            </Box>
            <Divider className={classes.formDivider} style={{ marginTop: "20px" }} />
            <Box className={classes.familyGroupButton}>
                <Box className={classes.divAccordionPrograms} style={{ minWidth: '240px !important' }}>
                    <FormControl className={`${classes.formControlChronicMedicationForm} ${classes.formControlsEmergency} ${classes.formControlSelect}`} variant="standard">
                        <CustomSelect
                            name={`familyGroup`}
                            list={familyGroupList}
                            selected={affiliatedSelected}
                            onChange={handleChangeSelect}
                            label='AFILIADO'
                            style={{ marginTop: "20px" }} />
                    </FormControl>
                </Box>
                <Box style={{ marginRight: '20px' }}>
                    <CustomButton title={screen.sWidth > 768 ? 'Preguntas Frecuentes' : ''} onClick={goToFrequentQuestions}
                        icon={<QuestionAnswerOutlinedIcon style={{ marginRight: "5px" }} />}
                        customClass={`${classes.buttonFrequentlyAskedQuestions}`}
                    />
                </Box>
            </Box>
            <Box className={classes.divSectionMovements} style={{ display: "flex", justifyContent: "center" }}>
                {selected?.length > 0 ?

                    selected?.map((item, i) => (
                        <MovementsCard
                            key={item?.id}
                            count={item?.count}
                            headerIcon={<HeaderCard day={item?.fechaFormateada?.nombreDia} numberDay={item?.fechaFormateada?.dia} month={Number.parseInt(item?.autorizacionGestionFecha?.split('-')[1])} year={item?.fechaFormateada?.anio} />}
                            description={
                                <>
                                    <Typography
                                        className={` ${classes.authorizationStatusText} ${classes.txtCardDescription} ${classes.txtEllipsis}`}
                                    >
                                        {item?.autorizacionEstadoDescripcion?.trim()}
                                    </Typography>
                                    <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis} ${classes.authorizationTypeText}`} >
                                        TIPO:  {item?.autorizacionTipoPrestacionDescripcion}
                                    </Typography>
                                    <Typography className={`${classes.authorizationNumberText} ${classes.txtCardDescription} ${classes.txtEllipsis}`}>
                                        AUTORIZACION Nº {item?.autorizacionNumero}
                                    </Typography>
                                    <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis} ${classes.authorizationTypeText}`}>
                                        SOLICITUD Nº: {item?.autorizacionGestionCodigo}
                                    </Typography>
                                </>
                            }
                            buttonZone={
                                <Box className={`${classes.sectionButtons} ${classes.btnAuthorizationCard}`}>
                                    <Box>
                                        <IconButton onClick={handleClickVerMas(item)} customClass={`${classes.customHeaderBtn}`}>
                                            <Typography className={`${classes.iconButtonAuthorizationRequest}  ${classes.txtCardDescription} ${classes.txtEllipsis}`}>
                                                VER
                                            </Typography>
                                            <ControlPointOutlinedIcon className={classes.iconButtonControlPointOutlinedIcon} />
                                        </IconButton>
                                    </Box>
                                    <Box style={{ paddingRight: '7%' }}>
                                        {setButtons(item)}
                                    </Box>
                                </Box>
                            } index={i} />
                    ))
                    :
                    <NotFound
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                        customMsg={
                            <Box className={classes.contentNotFound}>
                                <Typography>No se registraron autorizaciones</Typography>
                            </Box>}
                        wsItem={selected}
                        fullItem={selected}
                        loading={loading}
                    />
                }
            </Box>
            {
                openModal &&
                <ModalActivities
                    title={
                        <Box className={classes.modalDownloadButton}>
                            <Typography>Descargar</Typography>
                        </Box>
                    }
                    description={
                        <Box style={{ display: 'flex', justifyContent: 'center', margin: '5px' }}>
                            <Box component="a" href={`data:image/png;base64,${itemSelected?.archivo}`} download={itemSelected?.archivoNombreCompleto}>
                                <IconButton style={{ backgroundColor: '#ffffff', borderRadius: '15px' }}>
                                    <FileDownloadIcon className={classes.actionsIcons} />
                                </IconButton>
                            </Box>
                        </Box>
                    }
                    loading={loadingDownloadAuthorization}
                    open={openModal}
                    onClose={setOpenModal}
                    modalconfirm={false}
                    modalLogout={false}
                />
            }
            {showErrorMessageModal(errorMessage, openError, setOpenError, classes.borderWhite, classes.quickAccessIcon)}

            {
                openCancelAuthorizationModal &&
                <ModalActivities
                    title={'Anular solicitud'}
                    description={
                        <>
                            <Box
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                Estás por anular la solicitud de autorización seleccionada
                            </Box>
                            <Box
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: '20px'
                                }}>
                                ¿Querés continuar?
                            </Box>
                        </>
                    }
                    buttonType={'submit'}
                    onClose={setOpenCancelAuthorizationModal}
                    modalconfirm={true}
                    open={openCancelAuthorizationModal}
                    modalLogout={false}
                    handleClick={handleClickCancelAuthorization()}
                    style={{ textAlign: 'center' }}
                />
            }

            {
                openNullifyAuthorizationModal &&
                <ModalActivities
                    title={
                        <Box style={{ marginTop: "30px" }}>Anulando autorización ...</Box>
                    }
                    description={
                        <Box
                            className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.whiteCircularProgress}`}>
                            <CircularProgress />
                        </Box>
                    }
                    onClose={setNullifyAuthorizationModal}
                    open={openNullifyAuthorizationModal}
                    style={{ textAlign: 'center' }}
                    modalLogout={false}
                    modalconfirm={false}
                />
            }

            {
                cancelledAuthorization &&
                <ModalActivities
                    title={"Autorización anulada"}
                    description={
                        <Box style={{ display: 'flex', justifyContent: 'center' }}>
                            La solicitud seleccionada ha sido anulada
                        </Box>
                    }
                    onClose={setCancelledAuthorization}
                    open={cancelledAuthorization}
                    modalLogout={false}
                    style={{ textAlign: 'center' }}
                    modalconfirm={false}
                />
            }
        </>
    );
};

export default AuthorizationsIndex;